import styled from 'styled-components';

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const IconWrapper = styled.div`
  box-sizing: border-box;
  padding: 4px;
`;
